import { useEffect, useState } from "react";
import {
  FormControlLabel,
  Select,
  Switch,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import { green } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import { Field, Form, Formik } from "formik";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import States from "../../helpers/States";
import api from "../../services/api";
import { array } from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  multFieldLine: {
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const CompanyModal = ({ open, onClose, companyId }) => {
  const classes = useStyles();
  const initialState = {
    name: "",
    fantasyName: "",
    stateRegistration: "",
    segment: "",
    cnpj: "",
    status: true,
    partnerCustomer: false,
    deactivationAt: "",
    email: "",
    seller: "",
    origin: "",
    representative: "",
    source: "",
    size: "",
    address: "",
    number: "",
    complement: "",
    cep: "",
    district: "",
    city: "",
    uf: "",
    usersManagement: true,
    whatsappActive: true,
    instagramActive: false,
    waBusinessActive: false,
    whatsmeowActive: false,
    maxWhatsapps: 1,
    maxInstagrams: 0,
    maxWaBusiness: 0,
    maxWhatsMeows: 0,
    maxUsers: 1,
    modules: [],
  };

  const [successCreate, setSuccessCreate] = useState(false);
  const [successMsgCreate, setMsgSuccessCreate] = useState({});
  const [company, setCompany] = useState(initialState);
  const [valor, setValor] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!companyId) {
        setValor("");
        setSuccessCreate("");
        setCompany(initialState);
        return;
      }

      try {
        setLoading(true);
        setValor("");

        const [companyResponse, modulesResponse] = await Promise.all([
          api.get(`/company/${companyId}`),
          api.get(`/companyModules/list`),
        ]);

        const { company, modules: companyModules } = companyResponse.data;

        let whatsappActive = Array.isArray(companyModules) && companyModules.findIndex(m => m.moduleId == 1) >= 0 ? true : false;
        let instagramActive = Array.isArray(companyModules) && companyModules.findIndex(m => m.moduleId == 2) >= 0 ? true : false;
        let waBusinessActive = Array.isArray(companyModules) && companyModules.findIndex(m => m.moduleId == 3) >= 0 ? true : false;
        let whatsmeowActive = Array.isArray(companyModules) && companyModules.findIndex(m => m.moduleId == 4) >= 0 ? true : false;

        setCompany({
          ...company,
          whatsappActive,
          instagramActive,
          waBusinessActive,
          whatsmeowActive,
          modules: Array.isArray(companyModules) ? companyModules.map((m) => m.moduleId) : [],
        });

        setValor(company.cnpj);
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [companyId, open]);

  const handleClose = () => {
    onClose();
    setCompany({ ...initialState });
  };

  const handleSaveCompany = async (values) => {
    const activeModules = [];
    if (values.whatsappActive) activeModules.push(1);
    if (values.instagramActive) activeModules.push(2);
    if (values.waBusinessActive) activeModules.push(3);
    if (values.whatsmeowActive) activeModules.push(4);

    const CompanyData = {
      ...values,
      cnpj: valor,
      modules: activeModules,
      maxWhatsapps: values.whatsappActive ? values.maxWhatsapps : 0,
      maxInstagrams: values.instagramActive ? values.maxInstagrams : 0,
      maxWaBusiness: values.waBusinessActive ? values.maxWaBusiness : 0,
      maxWhatsMeows: values.whatsmeowActive ? values.maxWhatsMeows : 0,
    };

    try {
      setLoading(true);
      if (companyId) {
        await api.put(`/company/${companyId}`, CompanyData);
        toast.success("Atualizado com sucesso!");
        handleClose();
      } else {
        await api.post("/company", CompanyData);
        toast.success("Cadastrado com sucesso!");
        setSuccessCreate(true);
        setMsgSuccessCreate({
          emailUser: CompanyData.email,
          nameCompany: CompanyData.name,
        });
      }
    } catch (err) {
      console.error({ err });
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const origens = ["VENDA INTERNA", "VENDA EXTERNA", "INDICAÇÃO"];

  const seguimentos = [
    "CALL CENTER",
    "COBRANÇA",
    "EDUCAÇÃO",
    "FINANCEIRO",
    "IMOBILIARIO",
    "INDUSTRIA",
    "RELIGIOSO",
    "SAÚDE",
    "SEGUROS",
    "SERVIÇO",
    "TI/TELECOM",
    "TRANSPORTE",
    "TURISMO",
    "VAREJO",
  ];

  const fontes = [
    "CLIENTES",
    "ELEV TECNOLOGIA",
    "ATENDIMENTO WHATS",
    "Conexa Digital",
    "EVENTO MKT",
    "GERENTE COMERCIAL",
    "MÍDIA",
    "RECEPTIVO GOOGLE",
    "RECEPTIVO PARCEIROS",
    "RECEPTIVO SITE",
    "REDE SOCIAL",
    "REPRESENTANTE",
  ];

  const tamanhos = [
    "1 ATÉ 10",
    "11 ATÉ 50",
    "51 ATÉ 100",
    "101 ATÉ 500",
    "501 ATÉ 1000",
    "ACIMA DE 10001",
  ];

  const mask = (v) => {
    v = v.replace(/\D/g, "");
    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
    v = v.replace(/(\d{4})(\d)/, "$1-$2");
    return v.substring(0, 18);
  };

  function handleChangeMask(event) {
    const { value } = event.target;
    setValor(mask(value));
  }

  return (
    <div className={classes.root}>
      <Dialog
        open={open == true ? true : false}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {companyId ? `${"Editar Empresa"}` : `${"Cadastrar Empresa"}`}
        </DialogTitle>
        <Formik
          initialValues={company}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveCompany(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting, setFieldValue }) => (
            <>
              {successCreate ? (
                <>
                  <DialogContent dividers>
                    <div>
                      <p>
                        A empresa <b>{successMsgCreate?.nameCompany}</b> foi
                        criada com sucesso!
                        <br />
                        E-mail Administrador:{" "}
                        <b>{successMsgCreate?.emailUser}</b>
                        <br />
                        Senha: <b>123456.</b>
                      </p>
                    </div>
                  </DialogContent>
                  <DialogActions dividers>
                    <Button
                      onClick={handleClose}
                      color="primary"
                      variant="outlined"
                    >
                      {"FINALIZAR"}
                    </Button>
                  </DialogActions>
                </>
              ) : (
                <Form style={{ padding: "10px" }}>
                  <DialogContent dividers>
                    <div className="form-row">
                      <Field type="hidden" name="adminId" />
                      <div className="form-group col-md-6">
                        <label>Razão social</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Razão social"}
                          type="text"
                          name="name"
                          required
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <label>Email de contato</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control "
                          placeholder={"Email de contato"}
                          type="email"
                          name="email"
                          required
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <label>CNPJ</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control "
                          placeholder={"00.000.000/0000-00"}
                          maxlength="18"
                          onChange={handleChangeMask}
                          value={valor}
                          type="text"
                          name="cnpj"
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Nome fantasia</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Nome fantasia"}
                          type="text"
                          name="fantasyName"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <label>Inscrição estadual</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control "
                          placeholder={"Inscrição estadual"}
                          maxlength="18"
                          type="text"
                          name="stateRegistration"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <label>Vendedor</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Vendedor"}
                          type="text"
                          name="seller"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <label>Representante</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Representante"}
                          type="text"
                          name="representative"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <label>Segmento</label>
                        <Field
                          as={Select}
                          native
                          style={{
                            padding: "6px",
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          type="text"
                          name="segment"
                        >
                          {seguimentos.map((seguimento) => (
                            <option key={seguimento} value={seguimento}>
                              {seguimento}
                            </option>
                          ))}
                        </Field>
                      </div>

                      <div className="form-group col-md-2">
                        <label>Origem</label>
                        <Field
                          as={Select}
                          native
                          style={{
                            padding: "6px",
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          type="text"
                          name="origin"
                        >
                          {origens.map((origem) => (
                            <option key={origem} value={origem}>
                              {origem}
                            </option>
                          ))}
                        </Field>
                      </div>

                      <div className="form-group col-md-2">
                        <label>Fonte</label>
                        <Field
                          as={Select}
                          native
                          style={{
                            padding: "6px",
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          type="text"
                          name="source"
                        >
                          {fontes.map((fonte) => (
                            <option key={fonte} value={fonte}>
                              {fonte}
                            </option>
                          ))}
                        </Field>
                      </div>

                      <div className="form-group col-md-2">
                        <label>Tamanho</label>
                        <Field
                          as={Select}
                          native
                          style={{
                            padding: "6px",
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          type="text"
                          name="size"
                        >
                          {tamanhos.map((tamanho) => (
                            <option key={tamanho} value={tamanho}>
                              {tamanho}
                            </option>
                          ))}
                        </Field>
                      </div>

                      <div className="form-group col-md-6">
                        <label>Endereço</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Endereço"}
                          type="text"
                          name="address"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <label>Número</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Número"}
                          type="text"
                          name="number"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <label>Complemento</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Complemento"}
                          type="text"
                          name="complement"
                        />
                      </div>
                      <div className="form-group col-md-4">
                        <label>Cep</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"CEP"}
                          type="text"
                          name="cep"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <label>Bairro</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Bairro"}
                          type="text"
                          name="district"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <label>Cidade</label>
                        <Field
                          style={{
                            borderColor: "#c4c4c4",
                            borderRadius: "3px",
                          }}
                          className="form-control"
                          placeholder={"Cidade"}
                          type="text"
                          name="city"
                        />
                      </div>
                      <div className="form-group col-md-2">
                        <label>UF</label>
                        <Field
                          as={Select}
                          native
                          style={{
                            padding: "6px",
                            borderColor: "#c4c4c4",
                            borderRadius: "2px",
                          }}
                          className="form-control"
                          type="text"
                          name="uf"
                        >
                          {States().map((state) => (
                            <option key={state.uf} value={state.uf}>
                              {state.name}
                            </option>
                          ))}
                        </Field>
                      </div>
                      <FormControlLabel
                        style={{ marginTop: "0px" }}
                        control={
                          <Field
                            as={Switch}
                            color="primary"
                            name="partnerCustomer"
                            checked={values.partnerCustomer}
                          />
                        }
                        label={
                          <Typography component="span">
                            <b>Cliente parceiro ?</b>
                          </Typography>
                        }
                        labelPlacement="end"
                      />
                        <div className="form-group col-md-12">
                          <label>N° Usuários</label>
                          <Field
                            as="input"
                            type="number"
                            style={{
                              padding: "6px",
                              borderColor: "#c4c4c4",
                              borderRadius: "3px",
                              width: "100%",
                            }}
                            className="form-control"
                            name="maxUsers"
                            min="1"
                            max="500"
                            onInput={(e) => {
                              if (e.target.value > 500) e.target.value = 500;
                              if (e.target.value < 1) e.target.value = 1;
                            }}
                          />
                        </div>
                    </div>
                    <div className="form-group col-md-12">
                      <div style={{ marginBottom: "15px" }}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "150px 100px 150px",
                            marginBottom: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <div>Módulos</div>
                          <div>Ativo</div>
                          <div>N° de Conexões</div>
                        </div>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "150px 100px 150px",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <div>WhatsApp</div>
                          <div>
                            <Field
                              as={Switch}
                              color="primary"
                              name="whatsappActive"
                              checked={values.whatsappActive}
                              onChange={(e) =>
                                setFieldValue(
                                  "whatsappActive",
                                  e.target.checked
                                )
                              }
                            />
                          </div>
                          <div>
                            <Field
                              style={{
                                width: "80px",
                                borderColor: "#c4c4c4",
                                borderRadius: "3px",
                                padding: "6px",
                              }}
                              className="form-control"
                              type="number"
                              name="maxWhatsapps"
                              min="0"
                              max="100"
                              disabled={!values.whatsappActive}
                            />
                          </div>
                        </div>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "150px 100px 150px",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <div>Instagram</div>
                          <div>
                            <Field
                              as={Switch}
                              color="primary"
                              name="instagramActive"
                              checked={values.instagramActive}
                              onChange={(e) =>
                                setFieldValue(
                                  "instagramActive",
                                  e.target.checked
                                )
                              }
                            />
                          </div>
                          <div>
                            <Field
                              style={{
                                width: "80px",
                                borderColor: "#c4c4c4",
                                borderRadius: "3px",
                                padding: "6px",
                              }}
                              className="form-control"
                              type="number"
                              name="maxInstagrams"
                              min="0"
                              max="100"
                              disabled={!values.instagramActive}
                            />
                          </div>
                        </div>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "150px 100px 150px",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <div>WhatsApp Business</div>
                          <div>
                            <Field
                              as={Switch}
                              color="primary"
                              name="waBusinessActive"
                              checked={values.waBusinessActive}
                              onChange={(e) =>
                                setFieldValue(
                                  "waBusinessActive",
                                  e.target.checked
                                )
                              }
                            />
                          </div>
                          <div>
                            <Field
                              style={{
                                width: "80px",
                                borderColor: "#c4c4c4",
                                borderRadius: "3px",
                                padding: "6px",
                              }}
                              className="form-control"
                              type="number"
                              name="maxWaBusiness"
                              min="0"
                              max="100"
                              disabled={!values.waBusinessActive}
                            />
                          </div>
                        </div>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "150px 100px 150px",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          <div>WhatsMeow</div>
                          <div>
                            <Field
                              as={Switch}
                              color="primary"
                              name="whatsmeowActive"
                              checked={values.whatsmeowActive}
                              onChange={(e) =>
                                setFieldValue(
                                  "whatsmeowActive",
                                  e.target.checked
                                )
                              }
                            />
                          </div>
                          <div>
                            <Field
                              style={{
                                width: "80px",
                                borderColor: "#c4c4c4",
                                borderRadius: "3px",
                                padding: "6px",
                              }}
                              className="form-control"
                              type="number"
                              name="maxWhatsMeows"
                              min="0"
                              max="100"
                              disabled={!values.whatsmeowActive}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={classes.multFieldLine}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        margin="dense"
                      ></FormControl>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={handleClose}
                      color="secondary"
                      disabled={loading}
                      variant="outlined"
                    >
                      {"cancelar"}
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      disabled={loading}
                      variant="contained"
                      className={classes.btnWrapper}
                    >
                      {companyId ? `${"Salvar"}` : `${"Cadastrar"}`}
                      {loading && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </Button>
                  </DialogActions>
                </Form>
              )}
            </>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default CompanyModal;
